import z from 'zod';
import { engineOperatingPeriodSchema } from './engine-events-ready.webhook.js';
const statusExclusionRefSchema = z.union([z.string(), z.object({ documentId: z.string() })]);
const statusLeadingOutcomeSchema = z.object({
    requested: statusExclusionRefSchema,
    resolvedReconstructedDocumentIds: z.array(z.string()),
    applied: z.boolean(),
    appliedReconstructedDocumentId: z.string().optional(),
    // Deliberately `z.string()`, not the enum: `StatusLeadingReason` (project.schema.ts) is the
    // DOCUMENTED set, and a consumer must treat a value outside it as "not applied, reason unknown"
    // rather than reject the envelope. Same rollout logic as the `.optional()` note below — Brain
    // adds a gate's name the moment a new gate can drop a pin, and an enum here would make every
    // consumer running ahead of its own upgrade throw away an otherwise valid project snapshot.
    reason: z.string().optional(),
    engineGateOverridden: z.object({ targetEsn: z.string(), resolvedEsn: z.string().nullable() }).optional(),
});
export const projectStatusLeadingOutcomesSchema = z.object({
    ad: statusLeadingOutcomeSchema.optional(),
    sb: statusLeadingOutcomeSchema.optional(),
    llp: statusLeadingOutcomeSchema.optional(),
    qec: statusLeadingOutcomeSchema.optional(),
    ldnd: statusLeadingOutcomeSchema.optional(),
});
export const projectDataReadyWebhookSchema = z.looseObject({
    type: z.literal('project-data-ready'),
    projectId: z.string(),
    generatedAt: z.string(),
    esn: z.string().nullable(),
    engineType: z.string().nullable(),
    manufactureDate: z.string().nullable(),
    // Same `.optional()` rollout rationale as `statusLeading` below: Brain always emits it
    // (`emitProjectDataReady`, pinned by its test), and an envelope in flight from a Brain
    // that predates DR-4129 carries no key at all — a required field here would make an
    // upgraded consumer reject it.
    manufactureDatePrecision: z.enum(['day', 'month']).nullable().optional(),
    // `.optional()` is a ROLLOUT concession, not a statement that the field is dispensable —
    // Brain always emits it (`emitProjectDataReady`, pinned by its test), and `null` is a real
    // retraction rather than an absence. This schema is a member of `webhookPayloadSchema`, so a
    // REQUIRED field would make a consumer that upgrades `@avisoma/shared` reject every older
    // envelope still in flight, for as long as it runs ahead of Brain's own deploy. Tighten to
    // required in a later release, once no unstamped envelope can still be in flight (DR-3278).
    statusLeading: projectStatusLeadingOutcomesSchema.nullable().optional(),
    // DR-4660: the finalize's `projects.webhook_generation`, same shape as ARC/workscope. Optional
    // for the same rollout reason as above.
    generation: z.number().int().positive().max(2_147_483_647).optional(),
    // DR-5995: additive and OPTIONAL; absent means unknown. See `WebhookProjectDataReady.operatingPeriods`.
    operatingPeriods: z.array(engineOperatingPeriodSchema).optional(),
});
//# sourceMappingURL=project-data-ready.webhook.js.map